import { Language } from '@coolblue-development/constants';
import { convertDatePartsToObject, getLocale } from '../helpers.js';
/**
 * function: formatShortDate
 * Pattern: ShortDateFormat
 * Example: 19 januari
 *
 * Variations in PHP
 * nl_NL: 'd MMMM'
 * fr_BE: 'd MMMM'
 * en_US: 'd MMMM'
 * de_DE: 'd. MMMM'
 */
export function formatShortDate({ date = new Date(), language, subsidiary, }) {
    const locale = getLocale(language, subsidiary);
    const dateFormat = new Intl.DateTimeFormat(locale, {
        month: 'long',
        day: 'numeric',
    });
    const parts = dateFormat.formatToParts(date);
    const { day, month } = convertDatePartsToObject(parts);
    if (language === Language.GERMAN) {
        return `${day}. ${month}`;
    }
    return `${day} ${month}`;
}
//# sourceMappingURL=formatShortDate.js.map